function addParent(obj, parent) {
    obj.parent = parent;
    if (parent.children.includes(obj)) {
        throw new Error('obj is already a child of parent');
    }
    parent.children.push(obj);
}

export { addParent };
//# sourceMappingURL=add-parent.js.map
